export const Carriers = {
  UPS: {
    carrierId: '3',
  },
  FEDEX: {
    carrierId: '4',
  },
  FEDEX_CANADA: {
    carrierId: '12',
  },
  FEDEX_INTERNATIONAL_MAILSERVICE: {
    carrierId: '10',
  },
  FEDEX_UK: {
    carrierId: '32',
  },
  USPS: {
    carrierId: '1',
    name: 'USPS',
  },
  CANADA_POST: {
    carrierId: '11',
  },
};
